/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured `sans` font-family by default.
5. Use the user's configured `sans` font-feature-settings by default.
6. Use the user's configured `sans` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured `mono` font-family by default.
2. Use the user's configured `mono` font-feature-settings by default.
3. Use the user's configured `mono` font-variation-settings by default.
4. Correct the odd `em` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent `sub` and `sup` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to `inherit` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.z-10 {
  z-index: 10;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-auto {
  aspect-ratio: auto;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-\[200px\] {
  height: 200px;
}
.h-\[250px\] {
  height: 250px;
}
.h-full {
  height: 100%;
}
.max-h-\[100px\] {
  max-height: 100px;
}
.min-h-\[250px\] {
  min-height: 250px;
}
.w-full {
  width: 100%;
}
.grow {
  flex-grow: 1;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.gap-4 {
  gap: 1rem;
}
.gap-8 {
  gap: 2rem;
}
.overflow-hidden {
  overflow: hidden;
}
.border-b-\[1px\] {
  border-bottom-width: 1px;
}
.border-transparent {
  border-color: transparent;
}
.bg-brand {
  --tw-bg-opacity: 1;
  background-color: rgb(0 68 106 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-4 {
  padding: 1rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-\[0\.5px\] {
  padding-top: 0.5px;
  padding-bottom: 0.5px;
}
.text-left {
  text-align: left;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-semibold {
  font-weight: 600;
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(19 121 200 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
h1,
h2,
h3,
h4,
h5,
p,
span,
a {
  line-height: 120%;
}
.bg-emphasis {
  background-color: #f0f3f5;
}
/* RICH TEXT EDITOR */
.amp-rte-container > * {
  --tw-text-opacity: 1;
  color: rgb(10 36 51 / var(--tw-text-opacity));
}
.amp-rte-container :first-child {
  margin-top: 0px;
}
.amp-rte-container h2,
.amp-rte-container h3,
.amp-rte-container h4 {
  margin-top: 1rem;
  font-weight: 600;
}
.amp-rte-container h2 {
  font-size: 1.5rem;
  line-height: 2rem;
}
.amp-rte-container h3 {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.amp-rte-container h4 {
  font-size: 1rem;
  line-height: 1.5rem;
}
.amp-rte-container strong {
  font-weight: 700;
}
.amp-rte-container span {
  overflow: hidden;
}
.amp-rte-container a,
.amp-rte-container p > a {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(19 121 200 / var(--tw-text-opacity));
}
.amp-rte-container a:hover,
.amp-rte-container p > a:hover {
  text-decoration-line: underline;
}
.amp-rte-container p {
  max-width: 945px;
  line-height: 1.4;
}
.amp-rte-container blockquote {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.amp-rte-container blockquote > p {
  margin-right: 1rem;
  border-left-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(168 178 184 / var(--tw-border-opacity));
  padding-left: 1rem;
  font-style: italic;
}
.amp-rte-container img {
  height: 100%;
  max-height: 350px;
  width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  -o-object-position: left;
     object-position: left;
}
.amp-rte-container ul {
  -moz-column-count: auto;
       column-count: auto;
  -moz-column-width: 25ch;
       column-width: 25ch;
  margin-bottom: -0.5rem;
  -moz-column-gap: 4rem;
       column-gap: 4rem;
  padding-left: 1.5rem;
}
.amp-rte-container ul > li {
  margin-bottom: 0.5rem;
  list-style-type: disc;
}
.amp-rte-container ol {
  -moz-column-count: auto;
       column-count: auto;
  -moz-column-width: 25ch;
       column-width: 25ch;
  margin-bottom: -0.5rem;
  -moz-column-gap: 4rem;
       column-gap: 4rem;
  padding-left: 2rem;
}
.amp-rte-container ol > li {
  margin-bottom: 0.5rem;
  list-style-type: decimal;
}
.amp-rte-container thead tr {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(168 178 184 / var(--tw-border-opacity));
}
.amp-rte-container thead tr th {
  padding: 0.75rem;
  font-weight: 600;
}
.amp-rte-container thead tr th strong {
  font-weight: 600;
}
.amp-rte-container tbody tr {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(168 178 184 / var(--tw-border-opacity));
}
.amp-rte-container tbody td {
  border-left-width: 1px;
  border-right-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(168 178 184 / var(--tw-border-opacity));
  padding: 0.75rem;
}
.amp-rte-container th,
.amp-rte-container td {
  min-width: 100px;
}
@media (min-width: 768px) {
  .amp-rte-container blockquote {
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 4rem;
  }

  .amp-rte-container blockquote > p {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .amp-rte-container img {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
/* LOADING SPINNER */
.fg-icon-loader {
  display: none;
  width: 24px;
  height: 24px;
}
.loader-ferg-use,
.loader-ferg {
  width: 100px;
  height: 100px;
  overflow: visible;
}
.loader-logo {
  transform-origin: 50% 50%;
  animation-name: spinner-logoscale;
  animation-duration: 1350ms;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  fill: currentColor;
}
.loader-ferg .curve {
  transform: translate(0, 0);
  transform-origin: 50% 50%;
  animation-duration: 1000ms;
  animation-timing-function: ease-out;
  animation-delay: 200ms;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
.loader-ferg .curve-1 > path,
.loader-ferg .curve-2 > path,
.loader-ferg .curve-3 > path,
.loader-ferg .curve-4 > path {
  transform-origin: 50% 50%;
  animation-duration: 350ms;
  animation-timing-function: ease-out;
  animation-delay: 400ms;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
.loader-ferg .curve-1 {
  animation-name: spinner-curve, spinner-curve1;
}
.loader-ferg .curve-1 > path {
  transform-origin: 50% 50%;
  animation-name: spinner-curve1rotate;
  animation-timing-function: cubic-bezier(0.1, 0.97, 0.52, 1.83);
}
.loader-ferg .curve-2 {
  animation-name: spinner-curve, spinner-curve2;
}
.loader-ferg .curve-2 > path {
  transform-origin: 74% 27%;
  animation-name: spinner-curve2rotate;
}
.loader-ferg .curve-3 {
  animation-name: spinner-curve, spinner-curve3;
}
.loader-ferg .curve-3 > path {
  transform-origin: 50% 50%;
  animation-name: spinner-curve3rotate;
  animation-timing-function: cubic-bezier(0.1, 0.97, 0.52, 1.83);
}
.loader-ferg .curve-4 {
  transform-origin: 50% 50%;
  animation-name: spinner-curve, spinner-curve4;
}
.loader-ferg .curve-4 > path {
  transform-origin: 25% 75%;
  animation-name: spinner-curve4rotate;
}
.loader-circle {
  transform-origin: 50% 50%;
  opacity: 0;
  animation-name: spinner-circle;
  animation-duration: 1350ms;
  animation-timing-function: linear;
  animation-delay: 800ms;
  animation-iteration-count: infinite;
}
.loader-circle > circle {
  transform: rotate(0deg);
  transform-origin: center;
  animation-name: spinner-reset, spinner-circleinner;
  animation-duration: 1450ms, 1350ms;
  animation-timing-function: ease-in-out;
  animation-delay: 700ms, 2150ms;
  animation-iteration-count: 1, infinite;
  stroke: #00446a;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-dasharray: 185;
  stroke-dashoffset: 0;
}
@keyframes spinner-logoscale {
  0%,
  15% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.8);
  }

  40% {
    transform: scale(0.1);
  }

  55%,
  100% {
    transform: scale(1);
  }
}
@keyframes spinner-curve1 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(10%, 10%);
  }

  35% {
    transform: translate(calc(16% * -1), calc(16% * -1));
  }

  60%,
  100% {
    transform: translate(calc(3% * -1), calc(3% * -1));
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}
@keyframes spinner-curve2 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(-10%, 10%);
  }

  35% {
    transform: translate(16%, -16%);
  }

  60%,
  100% {
    transform: translate(3%, -3%);
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}
@keyframes spinner-curve3 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(-10%, -10%);
  }

  35% {
    transform: translate(16%, 16%);
  }

  60%,
  100% {
    transform: translate(3%, 3%);
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}
@keyframes spinner-curve4 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(10%, -10%);
  }

  35% {
    transform: translate(-16%, 16%);
  }

  60%,
  100% {
    transform: translate(-3%, 3%);
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}
@keyframes spinner-curve1rotate {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(4.3%, 2.9%);
  }
}
@keyframes spinner-curve2rotate {
  0% {
    transform: rotate(0deg) translate(0, 0);
  }

  100% {
    transform: rotate(-90deg) translate(-2.7%, -2.1%);
  }
}
@keyframes spinner-curve3rotate {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-3.6%, -4.4%);
  }
}
@keyframes spinner-curve4rotate {
  0% {
    transform: rotate(0deg), translate(0, 0);
  }

  100% {
    transform: rotate(-90deg) translate(4.4%, 3.6%);
  }
}
@keyframes spinner-reset {
  0%,
  100% {
    opacity: 1;
  }

  0% {
    stroke-dashoffset: 45;
    transform: rotate(-90deg);
  }

  50% {
    stroke-dashoffset: 140;
  }

  100% {
    stroke-dashoffset: 180;
    transform: rotate(810deg);
  }
}
@keyframes spinner-circle {
  0%,
  100% {
    opacity: 1;
  }

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(270deg);
  }
}
@keyframes spinner-circleinner {
  0%,
  100% {
    opacity: 1;
  }

  0% {
    stroke-dashoffset: 180;
  }

  50% {
    stroke-dashoffset: 80;
    transform: rotate(135deg);
  }

  100% {
    stroke-dashoffset: 180;
    transform: rotate(450deg);
  }
}
.hover\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(19 121 200 / var(--tw-border-opacity));
}
@media (min-width: 768px) {

  .md\:absolute {
    position: absolute;
  }

  .md\:relative {
    position: relative;
  }

  .md\:order-1 {
    order: 1;
  }

  .md\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .md\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .md\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .md\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .md\:aspect-square {
    aspect-ratio: 1 / 1;
  }

  .md\:h-auto {
    height: auto;
  }

  .md\:max-h-none {
    max-height: none;
  }

  .md\:min-h-\[250px\] {
    min-height: 250px;
  }

  .md\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\:gap-8 {
    gap: 2rem;
  }

  .md\:p-8 {
    padding: 2rem;
  }
}
